import React, { useState } from 'react';
import { DEPLOY_ENV, IS_PRODUCTION, SESSION_ID, SITE_WIDE_MESSAGE } from 'utils/globals';
import Button from 'components/shared/Button';

type SiteHeaderProps = {
  children?: React.ReactNode;
};

function SiteHeader({ children }: SiteHeaderProps) {
  const [showSessionId, setShowSessionId] = useState(true);

  return (
    <header className="header">
      <div className="accessibility-header" aria-label="accessibility">
        <section>
          <a href="#main-content">Skip Menu. Navigate to content in this page</a>
        </section>
        <section>
          <a href="https://bayphoto.com/accessibility/">
            Accessibility Assistance, opens A D A page
          </a>
        </section>
      </div>
      <div className="branding">
        <a className="logo" href="https://www.bayphoto.com">
          <span className="screen-reader-text">Bay Photo Lab - Web Ordering System</span>
        </a>
      </div>
      {!IS_PRODUCTION && showSessionId && (
        <div className="debug_header" data-testid="debug-header">
          <span>{DEPLOY_ENV}</span>
          <span>{SESSION_ID && ` - ${SESSION_ID}`}</span>
          <Button
            type="icon"
            icon="times"
            a11yText="Hide"
            onClick={() => setShowSessionId(false)}
          />
        </div>
      )}
      {SITE_WIDE_MESSAGE.enabled && (
        <div dangerouslySetInnerHTML={{ __html: SITE_WIDE_MESSAGE.value }} />
      )}
      <div id="site_nav" className="site_nav">
        {children}
      </div>
    </header>
  );
}

export default SiteHeader;
